import { db } from "@/firebaseConfig";

const uiMenuOrderCollection = db.collection("UI_menu_order");

const saveUiMenuOrder = async (id, data) => {
  uiMenuOrderCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("UiMenuOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateUiMenuOrder = async (id, data) => {
  uiMenuOrderCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("UiMenuOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteUiMenuOrder = async id => {
  uiMenuOrderCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("UiMenuOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getUiMenuOrderById = async id => {
  return uiMenuOrderCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  uiMenuOrderCollection,
  saveUiMenuOrder,
  updateUiMenuOrder,
  deleteUiMenuOrder,
  getUiMenuOrderById
};
